
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';

@Component
export default class BaseInput extends Vue {
    private readonly inputId: string = uuidv4();
    private innerValue: string = '';
    @Prop({ required: true }) readonly styledType!: 'input-nav-search' | 'input-filter-search' | 'input-filter-interval';
    @Prop({ required: false }) readonly label?: string;
    @Prop({ required: false }) readonly placeholder?: string;
    @Prop({ required: false }) readonly icon?: object;
    @Prop({ required: false }) readonly iconReset?: object;
    @Prop({ required: false }) readonly staticPlaceholder?: string;
    @Prop({ default: 'text' }) readonly type!: string;
    @Prop({ required: false }) readonly value?: string;

    @Watch('value', { immediate: true })
    onValueChange(newValue: string): void {
        this.innerValue = newValue || '';
    }

    get id(): string {
        return `input-${this.inputId}`;
    }

    onInput(event: Event): void {
        const target = event.target as HTMLInputElement;
        if (target) {
            this.innerValue = target.value;
            this.$emit('input', this.innerValue);
        }
    }

    onReset(): void {
        this.innerValue = '';
        this.$emit('input', this.innerValue);
    }
}
